import React from "react";
import { IAppContext } from "../../types";

export const AppContext = React.createContext({
  appname: undefined,
  appid: undefined,
  appguide: undefined,
} as IAppContext);

export const AppProvider = (props) => {
  const {
    children,
    appname = undefined,
    appid = undefined,
    appguide = undefined,
  } = props;

  return (
    <AppContext.Provider
      value={{
        appname,
        appid,
        appguide,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
